import React from 'react'
import './styles.css'
import SvgIcon, { iconList } from '../iconSVG'
import {  Star1 } from 'iconsax-react'

const CardGlobal = ({ data }) => {



    return (
        <div className='Contain-Card-Global' >
            <img src={data?.img} alt="imagen" />
            <div className='content-info-card-global'>
                <div className='column-a'>
                    <p className='column-a-price'>{data?.price} <span>COP</span></p>
                    <h3>{data?.title}</h3>
                    <p className='column-a-description'>{data?.descripcion}</p>
                </div>
                <div className='column-b'>
                    <span><SvgIcon color={'#FFFF00'} size={15} name={iconList.IconStar}/> {data?.stars}</span>
                    {
                        data.icon === 'no' ?
                        <span style={{color:'#004274'}}>{data.more}</span>
                        :
                        <SvgIcon name={data?.icon} size={35} color={'#000000'}/>
                    }
                    
                </div>
            </div>
        </div>
    )
}

export default CardGlobal